export default __webpack_public_path__ + "static/media/hero-caro-new-4.f191501a.png";